<style lang="scss">
  @import '../resources/scss/menu_mobile.scss';
</style>

<script lang="ts">
  import LocaleSwitcher from './LocaleSwitcher.svelte'
  import { menus } from '../stores/stores'
  import MenuItem from './MenuItem.svelte'
  import { Slugs } from '../config/slugs'
  import HeaderSearch from './Header_Search.svelte'
  import type Menu from '../api/rest/directus-cms/menus/model/Menu'

  export let lang: string

  let header_menus: Menu[] = []
  $: header_menus = $menus.filter(m => m.menu_type === 'header')
  let menu_news: Menu | undefined
  $: menu_news = $menus.find(m => m.slug === Slugs.News)
  let menu_newsletter: Menu | undefined
  $: menu_newsletter = $menus.find(m => m.slug === Slugs.Newsletter)
</script>

<div class="vstack h-100">
  <div class="mobile-search-container mb-2 pt-2 px-3">
    <HeaderSearch />
  </div>
  <div class="menu-container">
    <ul class="navbar-nav justify-content-center">
      {#each header_menus as menu}
        <MenuItem {menu} {lang} homepage={menu.slug === Slugs.About} main mobile />
      {/each}
    </ul>
  </div>
  <ul class="navbar-nav px-3">
    {#if menu_news}
      <MenuItem menu={menu_news} {lang} mobile />
    {/if}
    {#if menu_newsletter}
      <MenuItem menu={menu_newsletter} {lang} mobile />
    {/if}
  </ul>
  <div class="mb-4 px-3">
    <LocaleSwitcher mobile />
  </div>
</div>
